// Copyright (c) Bentley Systems

// Matches the Name150 / UniqueName limit enforced by validateField and the server.
export const NAME_MAX_LENGTH = 150;
export const COPY_NAME_SUFFIX = " - copy";
export const COPY_UNIQUE_NAME_SUFFIX = "_copy";

export function withCopySuffix(
  base: string,
  suffix: string,
  maxLength: number = NAME_MAX_LENGTH,
): string {
  return `${base.slice(0, maxLength - suffix.length)}${suffix}`;
}
